import type { ChipProps } from '@mui/material';
import { Chip } from '@mui/material';
import { ReviewStatus } from '@shared/domain/review';

interface ReviewStatusChipProps {
  status: ReviewStatus | string;
  sx?: ChipProps['sx'];
  size?: ChipProps['size'];
}

function getStatusColor(status: ReviewStatus | string): ChipProps['color'] {
  switch (status) {
    case ReviewStatus.COMPLETED:
      return 'success';
    case ReviewStatus.PENDING_APPROVAL:
      return 'warning';
    case ReviewStatus.IN_PROGRESS:
      return 'info';
    case ReviewStatus.NEEDS_EDITING:
      return 'warning';
    case ReviewStatus.REJECTED:
      return 'error';
    case ReviewStatus.ARCHIVED:
      return 'default';
    case ReviewStatus.DELETED:
      return 'error';
    default:
      return 'default';
  }
}

function formatStatusLabel(status: ReviewStatus | string): string {
  return status
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function ReviewStatusChip({ status, sx, size = 'small' }: ReviewStatusChipProps) {
  return (
    <Chip
      label={formatStatusLabel(status)}
      color={getStatusColor(status)}
      size={size}
      sx={{
        fontWeight: 600,
        ...sx,
      }}
    />
  );
}
